module.exports = __webpack_public_path__ + "media/images/emblems/Brugg-blason-5e5ec1e3e91997b242e960ce2eb768f5.svg";